var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{attrs:{"id":"sub"}})}
var staticRenderFns = []

export { render, staticRenderFns }